import { render, staticRenderFns } from "./RLogoIconSLO.vue?vue&type=template&id=76987612&scoped=true"
import script from "./RLogoIconSLO.vue?vue&type=script&lang=ts"
export * from "./RLogoIconSLO.vue?vue&type=script&lang=ts"
import style0 from "./RLogoIconSLO.vue?vue&type=style&index=0&id=76987612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76987612",
  null
  
)

export default component.exports